import {AbstractService} from 'services/AbstractService';

const ADVERTISERS_LIST_URL = '/api/advertisers';

export class AdvertisersService extends AbstractService {

  list (accountId) {
    return this.client.get(ADVERTISERS_LIST_URL, {}, {accountId});
  }

}
